import { createSelector } from 'reselect';
import precise from '../modules/precise';
import { VEHICLES } from '../modules/constants';
import getSecondYearFee from '../modules/getSecondYearFee';

const applySecondYearFeeSel = state => state.registration.applySecondYearFee;
const pipeStringSel = state => state.registration.selectedVehicleValue;
const svcTotalSel = state => state.registration.SVCFEE_TOTAL;
const BFfeeSel = state => state.registration.BFfee;
const vehicleWeightSel = state => state.registration.vehicleWeight;
const monthsFromNowSel = state => state.registration.monthsFromNow;
const selectedVehicleTypeSel = state => state.registration.selectedVehicleType;

const secondYearFeeTotalSelector = createSelector(
  [
    applySecondYearFeeSel,
    pipeStringSel,
    svcTotalSel,
    BFfeeSel,
    vehicleWeightSel,
    monthsFromNowSel,
    selectedVehicleTypeSel,
  ],
  (applySecondYearFee, pipe, svcFee, BFfee, vehicleWeight, monthsFromNow, selectedVehicleType) => {
    const svc = Number(svcFee);

    const total = getSecondYearFee({
      pipe,
      svc,
      BFfee,
      vehicleWeight: vehicleWeight || 0,
      monthsFromNow,
      selectedVehicleType,
      applySecondYearFee,
    });

    if (applySecondYearFee && selectedVehicleType === VEHICLES.VESSELS && Number(total) !== 0) {
      return precise(svc);
    }

    if (applySecondYearFee) {
      return precise(total);
    }
    return precise(0);
  },
);

export default secondYearFeeTotalSelector;



// WEBPACK FOOTER //
// ./src/selectors/secondYearFeeTotal.selector.js